import React, { Component } from 'react'
import { Switch } from 'react-router-dom'
import { Route } from 'react-router-dom'
import List from './scenes/List'
import Create from './scenes/Create'
import Edit from './scenes/Edit'

type Props = {
  match: any
}

export default class AdminProjects extends Component<Props> {
  render () {
    const {match} = this.props
    return (
      <Switch>
        <Route path={`${match.url}/edit/:id`} component={Edit} />
        <Route path={`${match.url}/create`} component={Create} />
        <Route path={`${match.url}/`} component={List} />
      </Switch>
    )
  }
}
